import { useApp } from '../../context/AppContext';
import { getStatusConfig } from '../../utils/helpers';

export default function TaskDistribution() {
  const { state } = useApp();
  const { tasks, boards } = state;

  const allStatuses = [...new Set(boards.flatMap((b) => b.columns.map((c) => c.status)))];

  const distribution = allStatuses.map((status) => {
    const count = tasks.filter((t) => t.status === status).length;
    const config = getStatusConfig(status);
    return { status, count, ...config };
  });

  const maxCount = Math.max(...distribution.map((d) => d.count), 1);

  const priorityDist = [
    {
      key: 'critical',
      label: 'Crítica',
      count: tasks.filter((t) => t.priority === 'critical').length,
      color: '#ef4444',
      bg: '#fef2f2',
      text: '#b91c1c',
    },
    {
      key: 'high',
      label: 'Alta',
      count: tasks.filter((t) => t.priority === 'high').length,
      color: '#f97316',
      bg: '#fff7ed',
      text: '#c2410c',
    },
    {
      key: 'medium',
      label: 'Média',
      count: tasks.filter((t) => t.priority === 'medium').length,
      color: '#f59e0b',
      bg: '#fffbeb',
      text: '#b45309',
    },
    {
      key: 'low',
      label: 'Baixa',
      count: tasks.filter((t) => t.priority === 'low').length,
      color: '#94a3b8',
      bg: '#f8fafc',
      text: '#475569',
    },
  ];

  const totalTasks = tasks.length || 1;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="bg-white rounded-2xl border border-slate-200 p-4">
        <h3 className="text-sm font-semibold text-slate-700 mb-3">Tarefas por Status</h3>

        <div className="space-y-2.5">
          {distribution.map((item) => (
            <div
              key={item.status}
              className="rounded-lg border border-slate-100 bg-slate-50/70 px-3 py-2"
            >
              <div className="flex items-center justify-between mb-1.5 gap-3">
                <span className="text-xs font-medium text-slate-700 truncate">
                  {item.label}
                </span>
                <span className="text-xs font-semibold text-slate-700">
                  {item.count}
                </span>
              </div>

              <div className="h-2 bg-white rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-700 ease-out"
                  style={{
                    width: `${(item.count / maxCount) * 100}%`,
                    backgroundColor: item.accent,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-semibold text-slate-700">Tarefas por Prioridade</h3>
          <span className="text-[11px] text-slate-500">
            Total: <strong className="text-slate-700">{tasks.length}</strong>
          </span>
        </div>

        <div className="space-y-2">
          {priorityDist.map((item) => {
            const percentage = Math.round((item.count / totalTasks) * 100);

            return (
              <div
                key={item.key}
                className="rounded-lg border border-slate-200 px-3 py-2"
                style={{ backgroundColor: item.bg }}
              >
                <div className="flex items-center justify-between gap-3 mb-1.5">
                  <div className="flex items-center gap-2 min-w-0">
                    <div
                      className="w-2.5 h-2.5 rounded-full shrink-0"
                      style={{ backgroundColor: item.color }}
                    />
                    <span
                      className="text-xs font-semibold truncate"
                      style={{ color: item.text }}
                    >
                      {item.label}
                    </span>
                  </div>

                  <div className="flex items-center gap-2 shrink-0">
                    <span className="text-[11px] font-medium text-slate-500">
                      {percentage}%
                    </span>
                    <span className="text-xs font-bold text-slate-700">
                      {item.count}
                    </span>
                  </div>
                </div>

                <div className="h-1.5 bg-white/80 rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full transition-all duration-700 ease-out"
                    style={{
                      width: `${Math.max(percentage, item.count > 0 ? 6 : 0)}%`,
                      backgroundColor: item.color,
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}